export default "__VITE_ASSET__983ea653__"